import Fetcher from "./FetchService";
// Private static variables
const baseUrl = "/aviso/alert/";
export default class AlertService {
    static getTemplatePreview(template, alertTypeId) {
        return Fetcher.getSingleResponse(baseUrl + "getTemplatePreview", {
            template,
            alertTypeId,
        });
    }
    static getStaffInitiatedAlertClosedTemplatePreview(template) {
        return Fetcher.getSingleResponse(baseUrl + "getStaffInitiatedAlertClosedPreview", { template });
    }
}
